// frontend/src/components/reorderLevels/useReorderLevels.js
//
// What ReorderLevelsProvider hands every page:
//
//   open    — () => void. Opens the reorder-levels grid dialog. Every entry
//             point calls this; none renders a dialog of its own.
//   status  — `{current_month, has_forecast_demand, show_welcome}` for the
//             selected store (hooks/useReorderLevelsData), or null until the
//             read lands and when it failed.

import { createContext, useContext } from 'react';

export const ReorderLevelsContext = createContext(null);

export function useReorderLevels() {
  const value = useContext(ReorderLevelsContext);
  if (!value) {
    throw new Error('useReorderLevels: rendered outside ReorderLevelsProvider');
  }
  return value;
}
